<script>
    import Fuse from 'fuse.js'
    import Modal from 'views/components/modals/Modal.svelte'
    import QuickInput from 'views/components/quickInput/QuickInput.svelte'
    import Avatar from 'views/components/avatar/Avatar.svelte'
    import Icon from 'views/components/icon/Icon.svelte'

    let modalIsOpen = $state(true)
    let query = $state('')

    // Fuse can only search on attributes, not on model methods
    const allStudents = Backbone.Collection.students.models.map(studentModel => ({
        id: studentModel.get('id'),
        model: studentModel,
        first_name_last_name: studentModel.first_name_last_name(),
    }))

    const fuse = new Fuse(allStudents, {
        keys: ['first_name_last_name'],
        threshold: 0.35,
    })

    const students = $derived(
        query.trim() === ''
            ? allStudents
            : fuse.search(query).map(({item}) => item)
    )

    function selectStudent(studentId) {
        modalIsOpen = false
        Backbone.history.navigate(`overview/progress/${studentId}`, {trigger: true})
    }

    function groupCount(studentId) {
        return Backbone.Collection.groups.filter(group => group.students.has(studentId)).length
    }
</script>

<Modal
    title={window.i18n.gettext('Select a student')}
    canBeClosedWithEscapeKey={true}
    bind:isOpen={modalIsOpen}
>
    <div class="search">
        <QuickInput
            type="search"
            placeholder={window.i18n.gettext('Search for a student…')}
            inputCallback={(value) => { query = value }}
            autoFocus={true}>
        </QuickInput>
    </div>

    <section>
        {#each students as student (student.id)}
            <button class="student-item" onclick={() => selectStudent(student.id)}>
                <span class="identity">
                    <Avatar model={student.model} showOnlineState={false}></Avatar>
                    <span class="name">{student.first_name_last_name}</span>
                </span>
                <span class="group-count" title={window.i18n.gettext('Number of classes')}>
                    <Icon name="people"></Icon>
                    {groupCount(student.id)}
                </span>
            </button>
        {:else}
            <span class="empty">{window.i18n.gettext('No students found.')}</span>
        {/each}
    </section>
</Modal>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.search {
  margin-bottom: 16px;
}

section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 50vh;
  overflow-y: auto;
}

.student-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid hsl(27, 15%, 93%);
  padding: 8px;
  border-radius: 12px;
  text-align: left;
}
.student-item:hover {
  background-color: hsl(40, 20%, 96%);
}
.student-item:hover .name {
  color: hsl(205, 60%, 44%);
}

.identity {
  display: flex;
  align-items: center;
  min-width: 0;
}

.name {
  font-size: 14px;
  margin-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-count {
  display: flex;
  align-items: center;
  flex: none;
  gap: 6px;
  padding: 4px 8px;
  background: rgba(18, 45, 64, 0.8);
  color: #fff;
  border-radius: 20px;
}
.group-count :global(svg) {
  width: 14px;
  height: 14px;
  fill: currentColor;
}

.empty {
  font-size: 14px;
  color: rgba(18, 45, 64, 0.5);
}</style>
